import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserConfigurationDal } from '../dal/userConfiguration.dal';
import { newUserConfiguration } from '../interfaces/userConfiguration.interfaces';
import { UserConfiguration } from '../models/userConfiguration.model';

@Injectable({
  providedIn: 'root',
})
export class UserConfigurationService {
  constructor(private readonly userConfigurationDal: UserConfigurationDal) {}

  getUserConfigurations(): Observable<UserConfiguration> {
    return this.userConfigurationDal.getUserConfigurations();
  }

  getAllUserConfigurations(): Observable<UserConfiguration[]> {
    return this.userConfigurationDal.getAllUserConfigurations();
  }

  modifyUserConfigurations(newUserConfiguration: newUserConfiguration): Observable<UserConfiguration> {
    return this.userConfigurationDal.modifyUserConfigurations(newUserConfiguration);
  }

  deletePopulation(id: string): Observable<UserConfiguration> {
    return this.userConfigurationDal.deletePopulation(id);
  }
}
